import React, { useEffect, useMemo, useState } from 'react';
import CatalogTableC from '../../components/Catalogs/CatalogTableC';
import Axios from '../../utils/axios';
import PaginatedTable from '../../components/Organismos/Table/PaginatedTable';
import ShapeEdit from '../../components/Atomos/Icons/ShapeEdit';
import useDataLoader2 from "../../hooks/useDataLoader2";
import { UseFirmList } from '../../hooks/Catalogs/useFirm';
import { defaultPageSize } from '../../utils/const';
import Filters, { IFilterData } from '../../components/Catalogs/Filters/Filters';
import PersistentLink from '../../components/Moleculas/PersistentLink';
import { IRepresentativeClient } from '../../interfaces/models/IRepresentativeClient';
import { formatTimeSpanToString } from '../../utils/functions';
import { exportAllDataLoader2 } from "../../utils/exportAllDataLoader2";

const axios = new Axios()

const RepresentativeClient: React.FC = ({ ...props }) => {
  const [officeData, setOfficeData] = useState<any>()
  const fields = [
    'id', 
    'name',
    'firm',
    'office',
    'firmName',
    'logo',
    'officeNames',
    'createdDate'
  ]
  const endpoint = '/representativeClient';
  const { 
    data, 
    totalCount, 
    fetchData, 
    setFilter, 
    sort, 
    setSort, 
    pagination, 
    setPagination,
    inputFilters,
    setInputFilters,
    filter,
  } = useDataLoader2<any>({
    endpoint,
    defaultPageSize,
    fields,
    defaultSorting: { field: "name", order: "asc" },
  });
const {firmData} = UseFirmList()

  const columnsDef = useMemo(() => [
    {
      id: "count",
      header: "#",
      enableSorting: false,
      cell: ({ rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <p> {rowIndex + 1 + pagination.pageIndex * pagination.pageSize} </p>
      ),
    },
    { id: 'name', header: 'Name' },
    { id: 'firm', header: 'Firm' },
    { id: 'office', header: 'Office' },
    { id: 'createdDate', header: "Created Date" },
    {
      id: 'edit',
      header: 'Edit',
      enableSorting: false,
      cell: ({ row }: { rowIndex: number; row: any; value: any }) => (
        <PersistentLink
          className="edit"
          to={`Edit/${row.id}`}
          state={row}
          persistingData={{
            pagination,
            sort,
            filter, 
            inputFilters, 
          }}
        >
          Edit{" "}
          <div className="editsvg">
            <ShapeEdit />
          </div>{" "}
        </PersistentLink>
      ),
    },
  ], [pagination.pageIndex, pagination.pageSize, sort, filter, inputFilters]);

  const formatData = (data: IRepresentativeClient[]) => {
      const formattedData = data.map(d => {
        return {
          ...d,
          firm: d.firmName,
          office: d.officeNames,
          createdDate: d.createdDate ? formatTimeSpanToString(d.createdDate) : '',
        };
      });
      return formattedData;
    };

  useEffect(() => {
    fetchOfficeData()
  }, []);

  const fetchOfficeData = async () => {
    try {
      const response = await axios.Get('./office')
      const data = response.data
      if (data != null) {
        setOfficeData(data)
      }
    } catch (error: any) {
      console.error(error)
    }
  }

  const filtersData: IFilterData[] = useMemo(() => [
    {
      name: "Client",
      fieldName: "name",
      type: "text",
      comparison: "CONTAINS",
    },
    {
      name: "Firm",
      objectData: firmData?.map((f: any) => ({id:f.id, name: f.name})) || [],
    },
    {
      name: "Office",
      objectData: officeData?.map((f: any) => ({id:f.id, name: f.name})) || [],
    },
  ], [firmData, officeData]);

  return (
    <>
        <CatalogTableC
          title={`Representative Client Catalog`}
          catalogName={'REPRESENTATIVE CLIENTS'}
          catalogShortName='REPRESENTATIVE CLIENT'
          route={'RepresentativeClient'}
          totalCount={totalCount}
        >
          <Filters
            filtersData={filtersData} 
            filterValues={inputFilters}
            setFilterValues={setInputFilters} 
            Search={() => fetchData()}
            clearSelections={() => fetchData(true)}
            setValueForQuery={setFilter}
          />
          <PaginatedTable
            data={data || []}
            columnsDef={columnsDef}
            formatData={formatData}
            sorting={sort}
            onSortingChange={setSort}
            totalCount={totalCount || 0}
            pagination={pagination}
            onPaginationChange={setPagination}
            endpoint={endpoint}
            onExportAll={() =>
              exportAllDataLoader2<any>({
                endpoint,
                filter,
                sort,
                pageSize: 1000,
                fields,
              })
            }
          />

        </CatalogTableC>
    </>
  );
};

export default RepresentativeClient;